var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "M10 12.5 7.5 10m2.5 2.5a18.6 18.6 0 0 0 3.333-1.667M10 12.5v4.167s2.525-.459 3.333-1.667c.9-1.35 0-4.167 0-4.167M7.5 10a18.3 18.3 0 0 1 1.667-3.292 10.73 10.73 0 0 1 9.166-5.041c0 2.266-.65 6.25-5 9.166M7.5 10H3.333S3.792 7.475 5 6.667c1.35-.9 4.167 0 4.167 0M3.75 13.75c-1.25 1.05-1.667 4.167-1.667 4.167S5.2 17.5 6.25 16.25c.592-.7.583-1.775-.075-2.425a1.816 1.816 0 0 0-2.425-.075"
  })));
};
export default SvgRocket;